import type { MouseEventHandler } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import InputChip from 'LuxKit/Chips/InputChip'
import { mediaQueryUp } from 'components/utils/breakpoint'

const SelectedChip = styled(InputChip)`
  display: none;
  grid-template-columns: minmax(0, 1fr) auto;
  min-width: 0;
  max-width: 100%;
  justify-content: space-between;
  height: auto;
  min-height: ${rem(28)};
  padding: ${rem(4)} ${rem(8)};
  text-align: start;
  &&.variant-filled {
    background-color: ${props => props.theme.palette.neutral.surface.lightBackgroundAlt};
    --chip-stroke-color: ${props => props.theme.palette.neutral.surface.lightForeground};
  }
  ${mediaQueryUp.desktop} { display: inline-grid; }
`

const Label = styled.span`
  display: block;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: ${rem(20)};
`

interface Props {
  count: number
  packageName: string
  onRemove: MouseEventHandler<HTMLButtonElement>
}

/** One removable choice for a same-package booking; the product owner clears the whole choice. */
export default function AccommodationPackageSelectionPill({ count, packageName, onRemove }: Props) {
  const intl = useIntl()
  const label = count > 1 ? intl.formatMessage({
    id: 'nrsR1UCRYQKc7NmktBKU',
    defaultMessage: '{count} × {packageName}',
    description: 'Selected package summary pill showing how many rooms share the same hotel package',
  }, { count, packageName }) : packageName
  const removeLabel = intl.formatMessage({
    id: 'Qc_KVLxEXG0YPylM2oJb',
    defaultMessage: 'Remove {count} × {packageName}',
    description: 'Accessible action that clears every selected room sharing this hotel package',
  }, { count, packageName })

  return <SelectedChip variant="filled" title={label} aria-label={removeLabel} onClick={onRemove}>
    <Label>{label}</Label>
  </SelectedChip>
}
